<script>
import { Line } from 'vue-chartjs'
import { apiGet, notify } from '../util/general'
export default {
  extends: Line,
  props : {
    tipo : {
      type   : String,
      default: 'Garantia'
    },
    desde : {
      type   : String,
      default: ''
    },
    hasta : {
      type   : String,
      default: ''
    }
  },
  data () {
    return {
      listaData : [],
      query: {
        titulo           : '',
        descripcion      : '',
        tipo             : '-1',
        desde            : '',
        hasta            : '',
        numero           : '',
        estado           : 0,
        codigoCliente    : '',
        serie            : '',
        modelo           : '',
        zona             : '-1',
        area             : '-1',
        abierto          : '-1',
        ingresoATaller   : '-1',
        tipoReporte      : 'basico'
      },
      chartData: {
        labels  : [],
        datasets: [
          {
            label          : `Cantidad`,
            data           : [],
            fill           : false,
            borderColor    : this.$vuetify.theme.themes.light.primary,
            backgroundColor: this.$vuetify.theme.themes.light.secondary,
            borderWidth    : 1
          }
        ]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            gridLines: {
              display: false
            },
            ticks : {
              fontSize: 11
            }
          }]
        },
        onClick:this.handle,
        legend: {
          display: false
        },
        responsive         : true,
        maintainAspectRatio: false
      }
    }
  },
  created () {
    var vm = this;
    vm.fetchEstados()
  },
  methods : {
    handle (point, event) {
      var vm = this
      var item = event[0]
      if (item) {
        var index        = item._index
        var estado       = vm.listaData[index]
        vm.query.estado  = estado.estado
        vm.query.abierto = 1
        vm.query.tipo    = vm.tipo.toLowerCase()
        var url          = vm.$router.resolve({ name  : 'reportes_view', params : {tipo : 'draft'}, query : vm.query })
        window.open(url.href, '_blank')
      }
    },
    render () {
      var vm = this
      vm.chartData.datasets[0].fill = !vm.$vuetify.theme.dark
      vm.renderChart(vm.chartData, vm.options)
    },
    fetchEstados () {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener listado de tickets abiertos' })
      var obj = {
        tipo : vm.tipo.toLowerCase(),
        desde : vm.desde,
        hasta : vm.hasta
      }
      apiGet(vm, '/ticket/abiertos/count/por/estado', obj, function (data) {
        vm.chartData.labels = data.labels
        vm.listaData        = data.valores
        for (var i = 0; i < data.valores.length; i++) {
          var e = data.valores[i];
          vm.chartData.datasets[0].data.push(e.abiertos)
        }
        vm.render()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
canvas
  max-height: 350px !important;
</style>



// WEBPACK FOOTER //
// c_chart_line_cantidad_tickets_abiertos_por_estado.vue?288a0de1